export default "__VITE_ASSET__EmcAwnOe__"